import React from 'react';
import { CtaButton } from '../CtaButton';
import { CountdownTimer } from '../CountdownTimer';
import { CheckList } from '../CheckList';
import { finalChecks, images } from '../../data/site';
const questions = ['Which movements are being planned?', 'What factors could affect their predictability?', 'Which biomechanical considerations deserve closer attention?', 'How will you evaluate whether the treatment is progressing as expected?'];
export function FinalCta() {
  return <section className="bg-navy-deep px-4 py-16 text-white md:px-8 md:py-24" data-id="element-143" data-mp="1iqem8wxa1odi">
      <div className="mx-auto max-w-3xl text-center" data-id="element-144" data-mp="14q3uzss227rt">
        <h2 className="font-display text-[28px] font-black leading-tight sm:text-4xl" data-id="element-145" data-mp="14rf66dntyhsy">
          Your Next Clear Aligner Case Deserves More Than a <span className="text-gold" data-id="element-146" data-mp="19r1jso7km02a">Promising Digital Simulation.</span>
        </h2>
        <p className="mt-4 font-display text-lg font-bold text-sky" data-id="element-147" data-mp="2z222nqapuvll">
          Understand the Movement. Evaluate the Risks. Plan With Greater Confidence.
        </p>

        <p className="mt-8 text-[16px] text-white/75" data-id="element-148" data-mp="27tso0g1uxyf">Every clear aligner treatment begins with clinical decisions.</p>
        <ul className="mx-auto mt-4 max-w-xl space-y-2 text-left" data-id="element-149" data-mp="3tf5zpmn7xv0m">
          {questions.map(q => <li key={q} className="rounded-xl bg-white/5 px-4 py-3 text-[15px] font-semibold text-white ring-1 ring-white/10" data-id="element-150" data-mp="b0ne6fm3atkq">
              {q}
            </li>)}
        </ul>
        <p className="mx-auto mt-6 max-w-2xl text-[16px] leading-relaxed text-white/75" data-id="element-151" data-mp="3fg6l77tf6wi6">
          DENTAL PREDICTABILITY ROADMAP™ gives you a structured clinical reference for exploring those questions. Instead of relying on scattered information, you’ll have six specialized volumes and five practical resources organized around the clear aligner planning process.
        </p>

        <img src={images.mockup} alt="Dental Predictability Roadmap complete collection" className="mx-auto mt-8 w-full max-w-md" loading="lazy" data-id="element-152" data-mp="13p2par23orqs" />

        <p className="mt-6 font-display text-xl font-black uppercase text-gold" data-id="element-153" data-mp="ytdji5zhmem1">Get instant digital access for just $27</p>
        <div className="mx-auto mt-6 max-w-xl text-left" data-id="element-154" data-mp="1cfywo1ux6ry">
          <CheckList items={finalChecks} tone="dark" columns data-id="element-155" data-mp="1av3yxbmrltk" />
        </div>

        <div className="mt-8 flex flex-col items-center gap-5" data-id="element-156" data-mp="5fkwqdazska9">
          <CtaButton label="Yes! I Want the Roadmap — $27" data-id="element-157" data-mp="adw84sgxr2ul" />
          <CountdownTimer data-id="element-158" data-mp="ab9z0oeecfa9" />
        </div>
      </div>
    </section>;
}